import React, { Fragment, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

// Helpers
import HasRole from "modules/5_view_helpers/HasRole";
import NewSliding from "./new_sliding";

const ProjectVariationNumberAddButton = ({ project_id,afterCreated }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const createRole = HasRole({ resource_type: "Project::VariationNumber", name: ["create", "moderator"] });

  // Hide button if the user does not have the role
  if (!createRole) {
    return null;
  }
  return (
    <Fragment>
      <FontAwesomeIcon
        className="ml-2"
        icon={faPlus}
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (!project_id) {
            toastr.error("Please select a project first");
          } else {
            setModalOpen(!modalOpen);
          }
        }}
      />

      {modalOpen && (
        <NewSliding
          isOpen={modalOpen}
          project_id={project_id}
          toggle={() => {
            setModalOpen(!modalOpen);
          }}
          afterCreated={afterCreated}
        />
      )}
    </Fragment>
  );
};

export default ProjectVariationNumberAddButton;
